import React, { FC } from "react";
import useEmblaCarousel from "embla-carousel-react";
import Fade from "embla-carousel-fade";
import classNames from "classnames";
import { TabSlide as ITabSlide } from "@app/components/base-page/models";
import { Tabs } from "@app/components/common/tabs/Tabs";
import { Slide } from "./components/slide/Slide";
import { useControls } from "./useControls";

type Props = {
  slides: ITabSlide[];
};

export const Carousel: FC<Props> = ({ slides }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false, duration: 60 }, [
    Fade(),
  ]);
  const { selectedIndex, onNavButtonClick } = useControls(emblaApi);

  const handleTabClick = (tabKey: string) => {
    const index = slides.findIndex((s) => s._uid === tabKey);

    if (index !== selectedIndex) {
      onNavButtonClick(index);
    }
  };

  return (
    <div className="relative">
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex">
          {slides.map((slide) => (
            <div key={slide._uid} className="flex-0-100 min-w-0">
              <Slide data={slide} />
            </div>
          ))}
        </div>
      </div>
      <div
        className={classNames(
          "pt-6",
          "lg:flex lg:justify-center lg:pt-7",
          "xl:absolute xl:inset-0 xl:mb-18 xl:items-end xl:p-0",
        )}
      >
        <div className={classNames("lg:w-full lg:px-15", "xl:w-auto xl:px-0")}>
          <Tabs
            tabs={slides.map((s) => ({ title: s.tabTitle, key: s._uid }))}
            activeTabKey={slides[selectedIndex]._uid}
            onTabChange={handleTabClick}
          />
        </div>
      </div>
    </div>
  );
};
